import React from 'react';
import ProductCard from './product-card'; // Ensure this path is correct
import { ChevronLeft, ChevronRight } from 'lucide-react'; // Ensure lucide-react is installed
import Food_Processor from '../../assets/goods/selling-product/food-processor.webp';
import Coffee_Maker from '../../assets/goods/selling-product/coffee-maker.webp';
import Vaccum_Cleaner from '../../assets/goods/selling-product/vaccum-cleaner.webp'
import Air_Purifier from '../../assets/goods/selling-product/air-purifier.webp'

// Sample data - updated for home appliances
const bestSellingProducts = [
  {
    id: '1',
    name: 'Multi-Function Food Processor',
    image: Food_Processor,
    price: 129.99,
    originalPrice: 169.99,
    rating: 4.5,
    reviewCount: 3654,
  },
  {
    id: '5',
    name: 'Smart Coffee Maker',
    image: Coffee_Maker ,
    price: 89.99,
    rating: 4.6,
    reviewCount: 1456,
    isNew: true,
  },
  {
    id: '6',
    name: 'Robotic Vacuum Cleaner',
    image: Vaccum_Cleaner,
    price: 199.99,
    rating: 4.7,
    reviewCount: 2345,
  },
  {
    id: '2',
    name: 'Digital Air Purifier',
    image: Air_Purifier,
    price: 149.99,
    originalPrice: 199.99,
    rating: 4.7,
    reviewCount: 1254,
  },
];

export default function BestSelling() {
  return (
    <section className="my-12">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl md:text-2xl font-bold mb-4 flex items-center text-gray-800">
          <span className="w-1 h-6 bg-[#ff9906] mr-2 inline-block"></span>
          Best Selling Products
        </h2>
        <div className="flex space-x-2">
          <button className="p-2 rounded-full border border-gray-200 hover:bg-gray-100 text-gray-600">
            <ChevronLeft size={20} />
          </button>
          <button className="p-2 rounded-full border border-gray-200 hover:bg-gray-100 text-gray-600">
            <ChevronRight size={20} />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {bestSellingProducts.map((product) => (
          <ProductCard key={product.id} {...product} />
        ))}
      </div>

      <div className="flex justify-center mt-8">
        <button className="bg-[#ff9906] text-white px-4 py-2 rounded-md hover:bg-[#e68a00] transition-colors">
          View All
        </button>
      </div>
    </section>
  );
}